import { Chip, List, ListItem, ListItemAvatar, ListItemText, ListSubheader } from "@material-ui/core";
import React from "react";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function FaqMenuTypeListHeaderString(props) {
  // console.log("FaqMenuType => List Header String Component");
  const classes = useStyles();
  // console.log("props data list: ", props.faqListHeaderStrData);

  let faqListHeaderStrData = props.faqListHeaderStrData;

  return (
    <>
      {faqListHeaderStrData.map((data, i) => (
        <List
          key={i}
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader>
              {data.listHeader}
            </ListSubheader>
          }
          className={classes.root}
        >
          {data.listContent.map((items, x) => (
            <ListItem key={x}>
              <ListItemAvatar>
                <Chip label={x + 1} size="small" />
              </ListItemAvatar>
              <ListItemText primary={items} />
            </ListItem>
          ))}
        </List>
      ))}
    </>
  );
}
